"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OmniEditorQuickInsertFeature = OmniEditorQuickInsertFeature;
const cas_1 = require("@branch-ts/cas");
function OmniEditorQuickInsertFeature(config) {
    cas_1.EditorEnvironmentRegistryMechanism.register({
        name: "VersetOmni",
        initEditor: (option) => {
            const editor = option.editor;
            editor.inputHotkeys.register({
                key: "input:<alt>o",
                handle: () => {
                    const heroViewport = editor.viewports.hero;
                    if (!heroViewport) {
                        return false;
                    }
                    if (heroViewport.situations.get("mode") !== "writer") {
                        return false;
                    }
                    if (heroViewport.situations.get("isHero") !== true) {
                        return false;
                    }
                    const fastSearchHud = config.omniCenter.createFastSearchHud({
                        allowContinuousSelect: true,
                    });
                    fastSearchHud.select().then(async (anchor) => {
                        heroViewport.promote();
                        const viewportWriter = heroViewport.getViewportLocalWriter();
                        const runeData = await cas_1.PuriRunePackage.createPuriRuneData({
                            uri: anchor.essenceURI,
                        });
                        viewportWriter.writes([runeData]);
                    });
                    return true;
                },
            });
        },
    }, config.editorKind);
}
